import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Card, Col, Row, Typography } from 'antd';

import { AuctionSummary, getAuctionDateDescription } from 'models/auction/Auction';
import { formatCurrency } from 'utils';

import styles from './AuctionCard.module.css';

const { Title, Text } = Typography;

interface AuctionCardProps {
  auctionSummary: AuctionSummary;
}

function AuctionCard({ auctionSummary }: AuctionCardProps) {
  const { id, title, thumbnail_url, current_price } = auctionSummary;

  const { description: dateDescription, state } = getAuctionDateDescription(auctionSummary);

  let [auctionStatusColor, auctionStatusText] = ['success', '종료'];
  if (state === 'active') {
    auctionStatusColor = '#52c41a';
    auctionStatusText = '진행 중';
  } else if (state === 'scheduled') {
    auctionStatusColor = '#faad14';
    auctionStatusText = '예정';
  }

  return (
    <Link to={`/auctions/${id}`}>
      <Card className={styles.card}>
        <Row className={styles.row}>
          <Col className={styles['image-container']} flex={0}>
            <img className={styles.image} src={thumbnail_url} alt={title} />
          </Col>
          <Col className="topdown-flex" flex="1 1 0">
            <Row className={styles.date} align="middle">
              <Col>
                <Badge count={auctionStatusText} color={auctionStatusColor} />
              </Col>
              <Col>
                <Text>{dateDescription}</Text>
              </Col>
            </Row>
            <Row className="topdown-flex stretch-flex-item" justify="space-between" align="stretch">
              <Col>
                <Title className={styles.title} level={2} ellipsis={{ rows: 2 }}>
                  {title}
                </Title>
              </Col>
              <Col>
                <Row justify="end">
                  <Title className={styles.price} level={2}>
                    {formatCurrency(current_price)}
                  </Title>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    </Link>
  );
}

export default memo(AuctionCard);
